module.exports = __webpack_public_path__ + "static/media/ecobee.37cffb9c.svg";